import { ReactComponent as AuthLog } from '../assets/img/icons/userSettings/authLog.svg';
import { ReactComponent as Security } from '../assets/img/icons/userSettings/security.svg';
import { ReactComponent as Sessions } from '../assets/img/icons/userSettings/sessions.svg';

import { ReactComponent as Administration } from '../assets/img/icons/sidebar/Administration.svg';
import { ReactComponent as Cameras } from '../assets/img/icons/sidebar/Cameras.svg';
import { ReactComponent as Dashboard } from '../assets/img/icons/sidebar/Dashboard.svg';
import { ReactComponent as Devices } from '../assets/img/icons/sidebar/Devices.svg';
import { ReactComponent as Events } from '../assets/img/icons/sidebar/Events.svg';
import { ReactComponent as KitchenPlayer } from '../assets/img/icons/sidebar/KitchenPlayer.svg';
import { ReactComponent as Monitoring } from '../assets/img/icons/sidebar/Monitoring.svg';
import { ReactComponent as Performance } from '../assets/img/icons/sidebar/Performance.svg';
import { ReactComponent as PlugPlay } from '../assets/img/icons/sidebar/PlugPlay.svg';
import { ReactComponent as Queue } from '../assets/img/icons/sidebar/Queue.svg';
import { ReactComponent as Reports } from '../assets/img/icons/sidebar/Reports.svg';
import { ReactComponent as Restaurants } from '../assets/img/icons/sidebar/Restaurants.svg';
import { ReactComponent as Settings } from '../assets/img/icons/sidebar/Settings.svg';
import { ReactComponent as StockOut } from '../assets/img/icons/sidebar/StockOut.svg';
import { ReactComponent as TimersCycleHistory } from '../assets/img/icons/sidebar/TimersCycleHistory.svg';
import { ReactComponent as Unusual } from '../assets/img/icons/sidebar/Unusual.svg';
import { ReactComponent as Waste } from '../assets/img/icons/sidebar/Waste.svg';
import { ReactComponent as Training } from '../assets/img/icons/sidebar/Training.svg';
import { ReactComponent as AIAssistant } from '../assets/img/icons/sidebar/AIAssistant.svg';
import { ReactComponent as Document } from '../assets/img/icons/sidebar/Document.svg';
import { ReactComponent as SystemAlerts } from '../assets/img/icons/sidebar/SystemAlerts.svg';

import * as R from './routes.constants';
import { KITCHEN_LOCATIONS } from './restaurants.constants';

export const pages = [
  {
    link: R.CHICKEN_DASHBOARD,
    i: 'fas fa-chart-pie',
    Icon: Dashboard,
    span: 'Dashboard',
    disabled: false,
    tooltip: [
      {
        link: R.CHICKEN_DASHBOARD,
        i: '',
        span: 'Summary',
        disabled: false,
      },
      {
        link: R.CHICKEN_CHARTS_DASHBOARD,
        i: '',
        span: 'Charts',
        disabled: false,
      },
      //TODO: return when is ready
      // {
      //   link: R.FRAHA_DASHBOARD,
      //   i: '',
      //   span: 'Potato',
      //   disabled: false,
      // },
    ],
  },
  {
    link: R.PRODUCTION_QUEUE,
    i: 'fas fa-list-alt',
    Icon: Queue,
    span: 'PCS',
    disabled: false,
    tooltip: [
      {
        link: R.PRODUCTION_QUEUE,
        span: 'Monitor',
        disabled: false,
      },
      {
        link: R.CATERING_INVENTORY,
        span: 'Scheduled Production',
        disabled: false,
      },
      {
        link: R.RECOMMENDATIONS,
        span: 'Recommendations',
        disabled: false,
      },
      {
        link: R.FRYER_MANAGER,
        span: 'Fryer Manager',
        disabled: false,
        kitchenLocation: KITCHEN_LOCATIONS.FRYER,
      },
      {
        link: R.ADJUSTMENT,
        span: 'Adjustment',
        disabled: false,
      },
    ],
  },
  {
    link: R.CHICKEN_EVENTS,
    i: 'fa fa-table',
    Icon: Events,
    span: 'Events',
    disabled: false,
    tooltip: [
      {
        link: R.CHICKEN_EVENTS,
        i: '',
        span: 'Chicken',
        disabled: false,
      },
      {
        link: R.POTATO_EVENTS,
        i: '',
        span: 'Potato',
        disabled: false,
      },
      {
        link: R.ANALYTIC_EVENTS,
        i: '',
        span: 'Analytics',
        disabled: false,
      },
    ],
  },
  {
    link: R.BREADING_EVENTS,
    i: 'fa fa-clock',
    Icon: TimersCycleHistory,
    span: 'Timers Cycle History',
    disabled: false,
    tooltip: [
      {
        link: R.BREADING_EVENTS,
        i: '',
        span: 'Breading',
        disabled: false,
        kitchenLocation: KITCHEN_LOCATIONS.BREADING,
      },
      {
        link: R.FRYER_EVENTS,
        i: '',
        span: 'Fryer',
        disabled: false,
        kitchenLocation: KITCHEN_LOCATIONS.FRYER,
      },
      {
        link: R.CONVEYOR_EVENTS,
        i: '',
        span: 'Conveyor',
        disabled: false,
        kitchenLocation: KITCHEN_LOCATIONS.CONVEYOR,
      },
      {
        link: R.HOT_HOLDING,
        i: '',
        span: 'Hot Holding',
        disabled: false,
        kitchenLocation: KITCHEN_LOCATIONS.HOT_HOLDING,
      },
      {
        link: R.MERCO_HOT_HOLDING,
        i: '',
        span: 'Merco Hot Holding',
        disabled: false,
        kitchenLocation: KITCHEN_LOCATIONS.MERCO_HOT_HOLDING,
      },
      {
        link: R.PRS_EVENTS,
        i: '',
        span: 'PRS',
        disabled: false,
        kitchenLocation: KITCHEN_LOCATIONS.PRS,
      },
      {
        link: R.ENTREE_CHUTES_EVENTS,
        i: '',
        span: 'Entree Chutes',
        disabled: false,
        kitchenLocation: KITCHEN_LOCATIONS.ENTREE_CHUTES,
      },
      {
        link: R.CATERING_EVENTS,
        i: '',
        span: 'Scheduled Production',
        disabled: false,
        kitchenLocation: KITCHEN_LOCATIONS.SCHEDULED_PRODUCTION,
      },
      // TODO: temporary hidden pages (search for 'hidden pages')
      // {
      //   link: R.PRQ_EVENTS,
      //   i: '',
      //   span: 'PRQ',
      //   disabled: false,
      // },
      // {
      //   link: R.DUMP_PAN_EVENTS,
      //   i: '',
      //   span: 'Dump Pan',
      //   disabled: false,
      // },
      // {
      //   link: R.FRY_CHUTES_EVENTS,
      //   i: '',
      //   span: 'Fry Chutes',
      //   disabled: false,
      // },
      {
        link: R.TIMERS_ANALYTICS,
        i: '',
        span: 'Analytics',
        disabled: false,
      },
    ],
  },
  {
    link: R.WASTE,
    i: 'fa fa-trash',
    Icon: Waste,
    span: 'Waste',
    disabled: false,
  },
  {
    link: R.STOCK_OUT_REPORTS,
    i: 'fas fa-cart-arrow-down',
    Icon: StockOut,
    span: 'Stock Out',
    disabled: false,
    tooltip: [
      {
        link: R.STOCK_OUT_REPORTS,
        i: '',
        span: 'Chicken',
        disabled: false,
      },
    ],
  },
  {
    link: R.CHICKEN_PERFORMANCE,
    i: 'fas fa-percent',
    Icon: Performance,
    span: 'Performance',
    disabled: false,
    tooltip: [
      {
        link: R.CHICKEN_PERFORMANCE,
        i: '',
        span: 'Chicken',
        disabled: false,
      },
    ],
  },
  {
    link: R.UNUSUAL_EVENT,
    i: 'far fa-surprise',
    Icon: Unusual,
    span: 'Unusual',
    disabled: false,
    tooltip: [
      {
        link: R.UNUSUAL_EVENT,
        i: '',
        span: 'Unusual Events',
        disabled: false,
      },
      {
        link: R.UNUSUAL_DP_REMAINING,
        i: '',
        span: 'DP Remaining Potato',
        disabled: false,
      },
      {
        link: R.UNUSUAL_WRONG_MARKER,
        i: '',
        span: 'Wrong Marker Detected',
        disabled: false,
      },
      {
        link: R.UNUSUAL_EMPTY_PAN,
        i: '',
        span: 'Empty Pan',
        disabled: false,
      },
      {
        link: R.UNUSUAL_IDENTICAL,
        i: '',
        span: 'Identical Markers',
        disabled: false,
      },
      {
        link: R.UNUSUAL_RECORDINGS,
        i: '',
        span: 'Unusual Recordings',
        disabled: false,
      },
    ],
  },
  {
    link: R.KITCHEN_PLAYER,
    i: 'fas fa-video',
    Icon: KitchenPlayer,
    span: 'Kitchen Player',
    disabled: false,
    tooltip: [
      {
        link: R.KITCHEN_PLAYER,
        i: 'fas fa-eye',
        span: 'Player',
        disabled: false,
      },
      {
        link: R.KITCHEN_PLAYER_CLIPS,
        i: 'fas fa-film',
        span: 'Clips',
        disabled: false,
      },
    ],
  },
  {
    link: R.PLUG_TAB,
    i: 'fas fa-play',
    Icon: PlugPlay,
    span: 'Plug & Play',
    disabled: false,
    tooltip: [
      {
        link: R.PLUG_TAB,
        i: '',
        span: 'PnP',
        disabled: false,
      },
      {
        link: R.ARUCO_VALIDATION,
        i: '',
        span: 'Aruco Validation',
        disabled: false,
      },
      {
        link: R.CHUTES_CONFIG,
        i: '',
        span: 'Entree Chutes',
        disabled: false,
        kitchenLocation: KITCHEN_LOCATIONS.ENTREE_CHUTES,
      },
    ],
  },
  {
    link: R.CAMERAS_MANAGEMENT_VIEW,
    i: 'fas fa-camera',
    Icon: Cameras,
    span: 'Cameras',
    disabled: false,
    tooltip: [
      {
        link: R.CAMERAS_MANAGEMENT_VIEW,
        i: 'fas fa-eye',
        span: 'View',
        disabled: false,
      },
      {
        link: R.CAMERAS_MANAGEMENT_SETTINGS,
        i: 'fas fa-cog',
        span: 'Management',
        disabled: false,
      },
      {
        link: R.CAMERAS_MANAGEMENT_CLIPS,
        i: 'fas fa-film',
        span: 'Media',
        disabled: false,
      },
    ],
  },
  {
    link: R.TRAINING,
    i: 'fas fa-folder',
    Icon: Training,
    span: 'Markup & Training',
    disabled: false,
  },
  {
    link: R.DEVICES_PC,
    i: 'fas fa-tablet-alt',
    Icon: Devices,
    span: 'Devices',
    disabled: false,
    tooltip: [
      {
        link: R.DEVICES_PC,
        i: '',
        span: 'PC',
        disabled: false,
      },
      {
        link: R.DEVICES_TABLETS,
        i: '',
        span: 'Tablets',
        disabled: false,
      },
    ],
  },
  {
    link: R.ASSISTANT_ACTIVITY,
    i: '',
    Icon: AIAssistant,
    span: 'AI Assistant',
    disabled: false,
    tooltip: [
      {
        link: R.ASSISTANT_ACTIVITY,
        i: '',
        span: 'Activity',
        disabled: false,
      },
      {
        link: R.ASSISTANT_HISTORY,
        i: '',
        span: 'History',
        disabled: false,
      },
    ],
  },
  {
    link: R.RESTAURANTS,
    i: 'fas fa-store',
    Icon: Restaurants,
    span: 'Restaurants',
    disabled: false,
  },
  {
    link: R.SERVER_MANAGEMENT,
    i: 'fas fa-chart-line',
    Icon: Monitoring,
    span: 'Monitoring',
    disabled: false,
    tooltip: [
      {
        link: R.SERVER_MANAGEMENT,
        i: '',
        span: 'Server Management',
        disabled: false,
      },
      {
        link: R.MONITORING_GRAPHICS,
        i: '',
        span: 'Graphics',
        disabled: false,
      },
      {
        link: R.MONITORING_PCS_CHARTS,
        i: '',
        span: 'PCS Charts',
        disabled: false,
      },
      {
        link: R.MONITORING_ALERTS,
        i: '',
        span: 'Alerts',
        disabled: false,
      },
    ],
  },
  {
    link: R.REPORTS,
    i: 'fas fa-file-invoice',
    Icon: Reports,
    span: 'Reports',
    disabled: false,
  },
  {
    link: R.SETTINGS_CHICKEN_MATERIALS,
    i: 'fa fa-cog',
    Icon: Settings,
    span: 'Settings',
    disabled: false,
    tooltip: [
      {
        link: R.SETTINGS_CHICKEN_MATERIALS,
        span: 'Chicken',
        disabled: false,
      },
      {
        link: R.SETTINGS_POTATO_MATERIALS,
        span: 'Potato',
        disabled: false,
      },
    ],
  },
  {
    link: R.ALERTS,
    i: '',
    Icon: SystemAlerts,
    span: 'Alerts & Support Groups',
    disabled: false,
    tooltip: [
      {
        link: R.ALERTS,
        span: 'Alerts',
        disabled: false,
      },
      {
        link: R.ALERT_DEFINITIONS,
        span: 'Alert Definitions',
        disabled: false,
      },
      {
        link: R.SUPPORT_GROUPS,
        span: 'Groups',
        disabled: false,
      },
      {
        link: R.SUPPORT_USERS,
        span: 'Users',
        disabled: false,
      },
    ],
  },
  {
    link: R.USERS,
    i: '',
    Icon: Administration,
    span: 'Administration',
    disabled: false,
    tooltip: [
      {
        link: R.USERS,
        span: 'Users',
        disabled: false,
      },
      {
        link: R.ROLES,
        span: 'Permissions',
        disabled: false,
      },
      {
        link: R.AUDIT_LOG,
        span: 'Audit Log',
        disabled: false,
      },
    ],
  },
  {
    link: R.RESOURCES,
    i: 'fa fa-file-o',
    Icon: Document,
    span: 'PCS Training',
    disabled: false,
  },
];

export const pagesByModules = [
  { module: 'DASHBOARD', pages: [R.CHICKEN_DASHBOARD, R.CHICKEN_CHARTS_DASHBOARD, R.FRAHA_DASHBOARD] },
  {
    module: 'PCS',
    pages: [
      R.PRODUCTION_QUEUE,
      R.CATERING_INVENTORY,
      R.RECOMMENDATIONS,
      R.FRYER_MANAGER,
      R.ADJUSTMENT,
      R.ADJUSTMENT_VERSIONS,
      R.ADJUSTMENT_VERSION,
      R.ADJUSTMENT_VERSION_COMPARISON,
    ],
  },
  { module: 'EVENTS', pages: [R.CHICKEN_EVENTS, R.POTATO_EVENTS, R.ANALYTIC_EVENTS] },
  {
    module: 'TIMER_CYCLE_HISTORY',
    pages: [
      R.HOT_HOLDING,
      R.MERCO_HOT_HOLDING,
      R.FRYER_EVENTS,
      R.DUMP_PAN_EVENTS,
      R.FRY_CHUTES_EVENTS,
      R.PRQ_EVENTS,
      R.PRS_EVENTS,
      R.BREADING_EVENTS,
      R.CONVEYOR_EVENTS,
      R.CATERING_EVENTS,
      R.ENTREE_CHUTES_EVENTS,
      R.TIMERS_ANALYTICS,
    ],
  },
  { module: 'WASTE_HISTORY', pages: [R.WASTE] },
  { module: 'STOCK_OUT', pages: [R.STOCK_OUT_REPORTS] },
  { module: 'PERFORMANCE', pages: [R.CHICKEN_PERFORMANCE] },
  {
    module: 'UNUSUAL',
    pages: [
      R.UNUSUAL_EVENT,
      R.UNUSUAL_DP_REMAINING,
      R.UNUSUAL_WRONG_MARKER,
      R.UNUSUAL_IDENTICAL,
      R.UNUSUAL_EMPTY_PAN,
      R.UNUSUAL_RECORDINGS,
    ],
  },
  { module: 'KITCHEN_PLAYER', pages: [R.KITCHEN_PLAYER, R.KITCHEN_PLAYER_CLIPS] },
  {
    module: 'PLUG_AND_PLAY',
    pages: [R.PLUG_TAB, R.ARUCO_VALIDATION, R.CHUTES_CONFIG, R.CHUTES_CONFIG_SETUP],
  },
  { module: 'TRAINING_MODE', pages: [R.TRAINING, R.TRAINING_DETAILS] },
  {
    module: 'CAMERAS',
    pages: [
      R.CAMERAS_MANAGEMENT_VIEW,
      R.CAMERAS_MANAGEMENT_SETTINGS,
      R.CAMERAS_MANAGEMENT_CLIPS,
      R.CAMERAS_MANAGEMENT_RECORDINGS,
    ],
  },
  {
    module: 'DEVICE',
    pages: [
      R.DEVICES_PC,
      R.DEVICES_TABLETS,
      R.RESTAURANTS_DEVICES_PC,
      R.RESTAURANTS_DEVICES_TABLETS,
      R.TABLET_SESSIONS,
      R.TABLET_SETTINGS,
    ],
  },
  // TODO
  //  { module: 'ASSISTANT', pages: [R.ASSISTANT_ACTIVITY, R.ASSISTANT_HISTORY] },
  { module: 'RESTAURANT', pages: [R.RESTAURANTS] },
  {
    module: 'MONITORING',
    pages: [R.MONITORING_GRAPHICS, R.MONITORING_ALERTS, R.SERVER_MANAGEMENT, R.MONITORING_PCS_CHARTS],
  },
  { module: 'REPORTS', pages: [R.REPORTS] },
  {
    module: 'MATERIAL_SETTINGS',
    pages: [
      R.SETTINGS_CHICKEN_MATERIALS,
      R.SETTINGS_CHICKEN_GRILLED_MATERIALS,
      R.SETTINGS_CHICKEN_CONTAINERS,
      R.SETTINGS_CHICKEN_MERCO_TRAYS,
      R.SETTINGS_CHICKEN_PACKAGES,
      R.SETTINGS_POTATO_MATERIALS,
      R.SETTINGS_POTATO_PACKAGES,
    ],
  },
  { module: 'SUPPORT', pages: [R.SUPPORT_HISTORY] },
  { module: 'PCS_TRAINING', pages: [R.RESOURCES] },
];

export const routeToModuleTypeMap = pagesByModules.reduce((acc, { module, pages }) => {
  if (Array.isArray(pages)) {
    pages.forEach((page) => {
      acc[page] = module;
    });
  } else {
    acc[pages] = module;
  }
  return acc;
}, {});

export const userSidebar = [
  {
    link: R.AUTHENTIFICATION_LOG,
    i: <AuthLog />,
    span: 'Authentication Log',
    disabled: false,
  },
  {
    link: R.ACTIVE_SESSIONS,
    i: <Sessions />,
    span: 'Active Sessions',
    disabled: false,
  },
  {
    link: R.USER_SECURITY,
    i: <Security />,
    span: 'Security',
    disabled: false,
  },
];
